export default function InitialsAvatar({ firstName, lastName, size = 36 }) {
    const initials = `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase()
    return (
        <span
            className="initials-avatar"
            style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}
            aria-hidden="true"
        >
            {initials}
        </span>
    )
}
